import React from "react";
import { OrderListUI } from "../Orders/OrdersListUI";

const Home = () => {
  return (
    <React.Fragment>
      <OrderListUI />
    </React.Fragment>
  );
};

export default Home;
